export const GET_TEST_BY_COURSE = "GET_TEST_BY_COURSE";
export const GET_TEST_BY_COURSE_LOADING = "GET_TEST_BY_COURSE_LOADING";
export const GET_TEST_BY_COURSE_SUCCESS = "GET_TEST_BY_COURSE_SUCCESS";
export const GET_TEST_BY_COURSE_ERROR = "GET_TEST_BY_COURSE_ERROR";

export const GET_TEST_RESULT = "GET_TEST_RESULT";
export const GET_TEST_RESULT_LOADING = "GET_TEST_RESULT_LOADING";
export const GET_TEST_RESULT_SUCCESS = "GET_TEST_RESULT_SUCCESS";
export const GET_TEST_RESULT_ERROR = "GET_TEST_RESULT_ERROR";
export const GET_TEST_RESULT_CLEAR = "GET_TEST_RESULT_CLEAR";

export const SET_TEST_INFO = "SET_TEST_INFO";
export const CLEAR_TEST_INFO = "CLEAR_TEST_INFO";

export const GET_TEST_QUESTIONS = "GET_TEST_QUESTIONS";
export const GET_TEST_QUESTIONS_LOADING = "GET_TEST_QUESTIONS_LOADING";
export const GET_TEST_QUESTIONS_SUCCESS = "GET_TEST_QUESTIONS_SUCCESS";
export const GET_TEST_QUESTIONS_ERROR = "GET_TEST_QUESTIONS_ERROR";

export const START_TEST_TIMER = "START_TEST_TIMER";
export const END_TEST_TIMER = "END_TEST_TIMER";

export const SET_TOTAL_QUESTION = "SET_TOTAL_QUESTION";
export const QUESTION_SAVE_AND_NEXT = "QUESTION_SAVE_AND_NEXT";
export const QUESTION_CLEAR = "QUESTION_CLEAR";
export const QUESTION_SAVE_AND_MARK_FOR_REVIEW =
  "QUESTION_SAVE_AND_MARK_FOR_REVIEW";
export const QUESTION_MARK_FOR_REVIEW_AND_NEXT =
  "QUESTION_MARK_FOR_REVIEW_AND_NEXT";
export const QUESTION_NEXT = "QUESTION_NEXT";
export const QUESTION_PREVIOUS = "QUESTION_PREVIOUS";

export const INSERT_TEST_DATA = "INSERT_TEST_DATA";
export const INSERT_TEST_DATA_LOADING = "INSERT_TEST_DATA_LOADING";
export const INSERT_TEST_DATA_SUCCESS = "INSERT_TEST_DATA_SUCCESS";
export const INSERT_TEST_DATA_ERROR = "INSERT_TEST_DATA_ERROR";

export const QUESTION_SAVE_AND_NEXT_EVAL = "QUESTION_SAVE_AND_NEXT_EVAL";
